// El fons corporatiu (Fons.jpg) es referencia des de public/images/: si es
// posa directament a controlhorari.css amb url("/images/..."), el
// css-loader de Create React App el tracta com un import de mòdul i falla
// en build ("Module not found"). La manera compatible amb CRA de
// referenciar un asset de public/ és process.env.PUBLIC_URL, i només
// funciona des de JS (style inline), no des d'un fitxer .css estàtic.
export const CH_ESTIL_FONS = {
  backgroundImage:
    `linear-gradient(rgba(255,255,255,0.88), rgba(255,255,255,0.9)), ` +
    `url(${process.env.PUBLIC_URL}/images/controlhorari/fons.jpg)`,
};
